/**
 * Tee Agent Main Component
 * 
 * AI-powered co-pilot for admin dashboard.
 * Renders the floating button (when closed) and the CopilotSidebar (when open).
 */
import { useEffect, useState } from "react";
import { CopilotSidebar } from "./CopilotSidebar";
import { useTeeAgentStore } from "@/zustand/useTeeAgentStore";
import { getCapabilities } from "@/services/teeAgentService";

// Always show TeeAgent in local dev regardless of capabilities, but never in
// production — prod must respect the server-provided capability gate.
const ALWAYS_SHOW_TEE_AGENT = import.meta.env.DEV;

export const TeeAgent = () => {
  const { setCapabilities, isCapable } = useTeeAgentStore();
  const [capabilitiesLoaded, setCapabilitiesLoaded] = useState(false);

  // Load capabilities on mount
  useEffect(() => {
    loadCapabilities();
  }, []);

  const loadCapabilities = async () => {
    try {
      console.log("🤖 TeeAgent: Loading capabilities...");
      const data = await getCapabilities();
      console.log("🤖 TeeAgent: Capabilities loaded:", data);
      setCapabilities(data.capabilities);
      setCapabilitiesLoaded(true);
    } catch (error) {
      console.error("🤖 TeeAgent: Failed to load capabilities:", error);
      setCapabilitiesLoaded(true);
      
      if (ALWAYS_SHOW_TEE_AGENT) {
        console.log("🤖 TeeAgent: ALWAYS_SHOW enabled, setting default capabilities");
        setCapabilities([
          {
            name: "chat",
            description: "Chat with TeeAgent AI",
            requires_confirmation: false,
            available: true,
          },
        ]);
      }
    }
  };

  if (!capabilitiesLoaded) {
    return null;
  }

  if (!isCapable && !ALWAYS_SHOW_TEE_AGENT) {
    return null;
  }

  return (
    <>
      <CopilotSidebar />
    </>
  );
};

